"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validation = exports.sanitization = void 0;
var utils_1 = require("../utils");
exports.sanitization = {
    type: 'array',
    items: {
        type: 'object',
        properties: {
            experimentId: {
                type: 'string',
                maxLength: utils_1.MAX_STR_LENGTH,
                rules: [
                    'trim',
                ],
            },
            experimentVariant: {
                type: 'string',
                maxLength: utils_1.MAX_STR_LENGTH,
                rules: [
                    'trim',
                ],
            },
        },
    },
};
/**
 * By making the array of experiments optional but the properties of each item
 * in the array not optional, it enables the requirement that if one property
 * in the experiment were provided, the other must be provided too.
 */
exports.validation = {
    type: 'array',
    optional: true,
    items: {
        type: 'object',
        properties: {
            experimentId: {
                type: 'string',
                optional: false,
            },
            experimentVariant: {
                type: 'string',
                optional: false,
            },
        },
    },
};
